import { useMemo } from 'react'

export type BrowserType = 'chrome' | 'firefox' | 'safari' | 'ie' | 'edge' | 'unknown'

const useNavigatorDetect = (): BrowserType => {
  const browser = useMemo(() => {
    const userAgent = navigator.userAgent

    if (userAgent.includes('Edg')) {
      return 'edge'
    }
    if (userAgent.includes('Chrome')) {
      return 'chrome'
    }
    if (userAgent.includes('Firefox')) {
      return 'firefox'
    }
    if (userAgent.includes('Safari')) {
      return 'safari'
    }
    if (userAgent.includes('Trident') || userAgent.includes('MSIE')) {
      return 'ie'
    }

    return 'unknown'
  }, [])

  return browser
}

export default useNavigatorDetect
